export default "__VITE_ASSET__DHn$mPnW__"